import React, { ReactNode } from "react";
import "./Card.scss";
// import { HiDotsVertical } from "react-icons/hi";

interface ICard {
  title: string;
  content: string;
  logo: string;
}

export default function Card({
  icon,
  item,
  handleCardClick,
  isCardClickDisabled,
  cardFooter,
  subTitle
  // buttonLabel,
}: {
  icon: any;
  item: ICard;
  handleCardClick?: any;
  isCardClickDisabled?: boolean;
  cardFooter?: ReactNode;
  subTitle?: ReactNode;
  // buttonLabel: string;
}) {
  return (
    <div
      className="card"
      onClick={() => {
        if (!isCardClickDisabled) {
          handleCardClick();
        }
      }}
    >
      <div className="card-header">
        <div className="header-title">
          {icon}
          {/* <img src={item.logo} alt="card-logo" /> */}
          <h3>{item.title}</h3>
        </div>
        {subTitle}
        {/* <Button rounded className="default">
          <HiDotsVertical />
        </Button> */}
      </div>
      <div className="card-content">
        <p>{item.content}</p>
      </div>
      {cardFooter && <div className="card-footer">{cardFooter}</div>}
    </div>
  );
}
